import { render, staticRenderFns } from "./CadastroFinanceiroCategorias.vue?vue&type=template&id=27fe80a2&"
import script from "./CadastroFinanceiroCategorias.vue?vue&type=script&lang=js&"
export * from "./CadastroFinanceiroCategorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports